import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import {
  SYSTEM_RECEIPT,
  SYSTEM_SIGN,
  SYSTEM_SCAN,
  SYSTEM_ACCESS_CONTROL,
  SYSTEM_GATE,
} from "@/config/constant.js";

import error from "../views/error/error.vue";

// 扫一扫
import scan from "../views/scan/scan.vue";

//凭证找回
import receipt from "../views/receipt/receipt.vue";

//自助门禁
import accessControl from "../views/accessControl/accessControl.vue";

// 新版自助门禁
import gate from "../views/gate/index.vue";
//自助签到
import sign from "../views/sign/sign.vue";
// 激活
import activation from "../views/activation/activation.vue";
// 快捷服务
import quickService from "../views/quickService/index.vue";

Vue.use(VueRouter);
const routes = [
  { path: "/error", name: "Error", component: error },

  // 扫一扫
  {
    path: "/scan",
    name: "Scan",
    component: scan,
  },
  // 回执路由
  {
    path: "/receipt",
    name: "Receipt",
    redirect: "/receipt/retrieve",
    component: receipt,
    children: [
      {
        path: "/receipt/retrieve",
        name: "Retrieve",
        component: () => import("../views/receipt/retrieve.vue"),
      },
      {
        path: "/receipt/detail",
        name: "Detail",
        component: () => import("../views/receipt/detail.vue"),
      },
    ],
  },
  {
    path: "/activation",
    name: "Activation",
    redirect: "/activation/retrieve",
    component: activation,
    children: [
      {
        path: "/activation/retrieve",
        name: "ActivationRetrieve",
        component: () => import("../views/activation/retrieve.vue"),
      },
      {
        path: "/activation/detail",
        name: "ActivationDetail",
        component: () => import("../views/activation/detail.vue"),
      },
      {
        path: "/activation/filling",
        name: "ActivationFilling",
        component: () => import("../views/activation/filling.vue"),
      },
    ],
  },
  // 签到路由
  {
    path: "/sign",
    name: "Sign",
    redirect: "/sign/login",
    component: sign,
    children: [
      {
        path: "/sign/login",
        name: "Login",
        component: () => import("../views/sign/login.vue"),
      },
      {
        path: "/sign/locale",
        name: "Locale",
        component: () => import("../views/sign/locale.vue"),
      },
      {
        path: "/sign/search",
        name: "Search",
        component: () => import("../views/sign/search.vue"),
      },
      {
        path: "/sign/signin",
        name: "Signin",
        component: () => import("../views/sign/signin.vue"),
      },
    ],
  },

  // 门禁系统
  {
    path: "/access-control",
    name: "AccessControl",
    redirect: "/access-control/login",
    component: accessControl,
    children: [
      {
        path: "/access-control/login",
        name: "AccessControlLogin",
        component: () => import("../views/accessControl/login.vue"),
      },
      {
        path: "/access-control/location",
        name: "AccessControlLocation",
        component: () => import("../views/accessControl/location.vue"),
      },
      {
        path: "/access-control/checkin",
        name: "AccessControlCheckin",
        component: () => import("../views/accessControl/checkin.vue"),
      },
      {
        path: "/access-control/info",
        name: "AccessControlInfo",
        component: () => import("../views/accessControl/information.vue"),
      },
    ],
  },

  // 新版门禁系统
  {
    path: "/gate",
    name: "Gate",
    redirect: "/gate/index",
    component: gate,
    children: [
      {
        path: "/gate/login",
        name: "GateLogin",
        component: () => import("../views/gate/login.vue"),
      },
      {
        path: "/gate/point",
        name: "GatePoint",
        component: () => import("../views/gate/point.vue"),
      },
      {
        path: "/gate/passageway",
        name: "GatePassageway",
        component: () => import("../views/gate/passageway.vue"),
      },
      {
        path: "/gate/entrance",
        name: "GateEntrance",
        component: () => import("../views/gate/entrance.vue"),
      },
    ],
  },

  // 快捷服务路由
  {
    path: "/quick-service",
    name: "QuickService",
    redirect: "/quick-service/search",
    component: quickService,
    children: [
      {
        path: "/quick-service/search",
        name: "QuickServiceSearch",
        component: () => import("../views/quickService/components/search.vue"),
      },
      {
        path: "/quick-service/manage",
        name: "QuickServiceManage",
        component: () => import("../views/quickService/components/manage.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, form, next) => {
  const alias = to.query.alias;
  // 不是前往错误页的情况下链接错误。跳转链接错误页
  if (!alias && to.path !== "/error" && to.path !== SYSTEM_SCAN) {
    next({ name: "Error", replace: true });
    return;
  } else {
    if (to.path === SYSTEM_SCAN) {
      return next();
    }
  }

  // 回执系统
  if (to.path.startsWith(SYSTEM_RECEIPT)) {
    // 加载回执配置
    const isRenderingCompleted =
      store.getters["receiptStore/getIsRenderingCompleted"];
    if (!isRenderingCompleted && alias) {
      await store.dispatch("receiptStore/setConfig", { alias });
      store.dispatch("receiptStore/setIsRenderingCompleted");
    }
  }

  // 签到系统
  if (to.path.startsWith(SYSTEM_SIGN)) {
    // 配置id
    const configuration = to.query.configuration;
    // 获取token
    const token = sessionStorage.getItem("accessToken");

    if (!token && to.path !== "/sign/login") {
      return next({ path: "/sign/login", query: { alias: to.query.alias } });
    }
    // // 动态加载活动配置信息
    // const isActivityRenderingCompleted =
    //   store.getters["signStore/getIsActivityRenderingCompleted"];
    // if (!isActivityRenderingCompleted && alias) {
    //   await store.dispatch("signStore/setDoings", { alias });
    //   store.dispatch("signStore/setIsActivityRenderingCompleted");
    // }

    // 动态加载签到配置信息
    const isSignRenderingCompleted =
      store.getters["signStore/getIsSignRenderingCompleted"];
    if (!isSignRenderingCompleted && alias) {
      await store.dispatch("signStore/setConfig", { alias });
      store.dispatch("signStore/setIsSignRenderingCompleted");
    }
  }

  // 门禁系统
  if (to.path.startsWith("/access-control")) {
    // 获取token
    const token = sessionStorage.getItem("accessToken");

    if (!token && to.path !== "/access-control/login") {
      return next({
        path: "/access-control/login",
        query: { alias: to.query.alias },
      });
    }
    const pointId = to.query.point;
    // 活动配置
    const isRenderingCompleted =
      store.getters["accessControlStore/accessControlerRenderingCompleted"];
    if (!isRenderingCompleted && !!alias) {
      await store.dispatch("accessControlStore/setDoings", { alias });
      store.dispatch(
        "accessControlStore/setIsAccessControlerRenderingCompleted"
      );
    }

    // 门禁点配置

    // 进入到地点选择页需要设置为未加载，重新获取配置
    if (to.path.startsWith("/access-control/location")) {
      store.dispatch("accessControlStore/setRenderConfigCompleted", false);
    }

    const isRenderConfigCompleted =
      store.getters["accessControlStore/getIsRenderConfigCompleted"];
    if (!isRenderConfigCompleted && !!alias && token && pointId) {
      const pointId = to.query.point;
      await store.dispatch("accessControlStore/setConfig", { pointId });
      store.dispatch("accessControlStore/setRenderConfigCompleted", true);
    }
  }

  // 新版门禁系统
  if (to.path.startsWith("/gate")) {
    // 获取token
    const token = sessionStorage.getItem("accessToken");

    if (!token && to.path !== "/gate/login") {
      return next({ path: "/gate/login", query: { alias: to.query.alias } });
    }
    // 活动配置
    const isRenderingCompleted =
      store.getters["gateStore/getActivityConfigRenderingCompleted"];
    if (!isRenderingCompleted && !!alias) {
      await store.dispatch("gateStore/setActivity", { alias });
      store.dispatch("gateStore/setActivityConfigRenderingCompleted");
    }
  }

  // 激活系统
  if (to.path.startsWith("/activation")) {
    // 加载配置
    const isRenderingCompleted =
      store.getters["activationStore/getConfigLoaded"];
    if (!isRenderingCompleted && alias) {
      await store.dispatch("activationStore/setConfig", { alias });
      store.dispatch("activationStore/setConfigLoaded", true);
    }
  }

  // 快捷服务系统
  if (to.path.startsWith("/quick-service")) {
    const isValidBeforeValidation = store.getters["quickServiceStore/getValid"];
    if (!isValidBeforeValidation) {
      await store.dispatch("quickServiceStore/validateUrlValidity", alias);

      const isValidAfterValidation =
        store.getters["quickServiceStore/getValid"];
      if (!isValidAfterValidation) {
        return next({
          name: "Error",
          replace: true,
          query: {
            title: "非法链接",
            msg: "链接无效或活动已结束，请联系管理员！",
          },
        });
      }
    }
  }

  next();
});

export default router;
